import React from 'react';
import Navbar from '../component/Navbar/NavbarCommon';
import ArrowButton from '../component/Common/ArrowButton';

const Engagement: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main className="max-w-5xl mx-auto px-6 py-24 text-center mt-14">
        <div className="mb-6">
          <ArrowButton />
        </div>
        <h1 className="text-3xl font-semibold text-gray-900 mb-6">Engagement</h1>

        <div className="mt-8 p-8 bg-gray-50 rounded-lg shadow-sm">
          <h2 className="text-xl font-medium mb-4">Coming soon</h2>
          {/* <p className="text-gray-700">
            Engagement features and resources will be available soon. Check back later.
          </p> */}
        </div>
      </main>
    </div>
  );
};

export default Engagement;
